import { Provider, ErrorHandler } from "@angular/core";
import { API_CONFIG, ApiConfig } from "@play/api-client";
import { environment } from "./environment";

export function apiUrlFactory(): ApiConfig {
    return {
        drupalBaseUrl: "/xapi",
        apiBaseUrl: `${environment.apiHost}`,
        playBaseUrl: `${environment.apiHost}/play/v1`,
        giBaseUrl: `${environment.apiHost}/gi/v1`,
        metarankBaseUrl: `${environment.apiHost}/metarank/v1`,
    };
}

export const apiUrlProvider: Provider = {
    provide: API_CONFIG,
    useFactory: apiUrlFactory,
    deps: [],
};

export function errorHandlerFactory(prodHandler: ErrorHandler): ErrorHandler {
    if (environment.drupalProduction) {
        return prodHandler;
    }

    return new ErrorHandler();
}
